export default __webpack_public_path__ + "static/media/insights-empty-gap-analysis-grayscale.f178a1b3.svg";